import { GET } from './../../constants';

export const ARTICLE_PAGE_CLEAR = 'ARTICLE_PAGE_CLEAR';
export const ARTICLE_PAGE_RESET = 'ARTICLE_PAGE_RESET';
export const ARTICLE_PAGE_FILL_DATA = 'ARTICLE_PAGE_FILL_DATA';
export const ARTICLE_PAGE_TOTAL_COUNT = 'ARTICLE_PAGE_TOTAL_COUNT';

function viewArticlePage(state = null, action) {

    switch (action.type) {

        case ARTICLE_PAGE_CLEAR:
            return {
                initialData:        [],
                url:                null,
                totalCount:         0,
                urlParams:          null,
                requestType:        GET,
                requestPayload:     null,
                embeddedResultList: null
            };

        case ARTICLE_PAGE_RESET:
            return Object.assign(
                {}, state, {
                    initialData: [],
                    url: action.payload.url,
                    totalCount: 0,
                    urlParams: action.payload.urlParams,
                    requestType: action.payload.requestType ? action.payload.requestType : state.requestType,
                    requestPayload: action.payload.requestPayload ? action.payload.requestPayload : state.requestPayload,
                    embeddedResultList: action.payload.embeddedResultList
                }
            );

        case ARTICLE_PAGE_FILL_DATA:
            let initialData = state.initialData.concat(action.payload);
            return Object.assign({}, state, {initialData: initialData});

        case ARTICLE_PAGE_TOTAL_COUNT:
            return Object.assign({}, state, {totalCount: action.payload});

        default:
            return state;

    }

}

export default viewArticlePage;


// WEBPACK FOOTER //
// ./src/scripts/reusable/PreviewArticle/ViewArticleWithNavigation.reducers.js